import Icon from '2-core-elements/Icon/Icon';
import InlineMessage from '3-components/InlineMessage/InlineMessage';
import LoadingIndicator from '3-components/LoadingIndicator/LoadingIndicator';
import { type FC } from 'react';

export interface ListingUILabel {
    errorMessage: string;
    noItemMessage: {
        messageTitle: string;
        messageContent?: string;
    };
    loadingMessage?: string;
}

type ListingLoaderProps = Pick<ListingUILabel, 'loadingMessage'>;

export const ListingLoader: FC<ListingLoaderProps> = ({ loadingMessage }) => {
    return (
        <div className="listing-loader">
            <LoadingIndicator loadingText={loadingMessage} className="sg-eg-loader" />
        </div>
    );
};

type ListingErrorProps = Pick<ListingUILabel, 'errorMessage'>;

export const ListingError: FC<ListingErrorProps> = ({ errorMessage }) => {
    return (
        <div className="listing-app">
            <div className="container">
                <InlineMessage status="error">
                    <p>{errorMessage}</p>
                </InlineMessage>
            </div>
        </div>
    );
};

type ListingNoItemProps = Pick<ListingUILabel, 'noItemMessage'>;

export const ListingNoItem: FC<ListingNoItemProps> = ({ noItemMessage }) => {
    const { messageTitle, messageContent } = noItemMessage;

    return (
        <div className="listing-no-item">
            <div className="listing-no-item-container">
                <div className="listing-no-item-icon-box">
                    <Icon className="listing-no-item-icon" icon="search" />
                </div>
                <div className="listing-no-item-description">
                    <div className="listing-no-item-title">{messageTitle}</div>
                    {messageContent && (
                        <div className="listing-no-item-content">{messageContent}</div>
                    )}
                </div>
            </div>
        </div>
    );
};
